import React from "react";
import { useNavigate } from "react-router-dom";

export default function GoBackButton({ label = "Go Back", className = "" }) {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(-1)}
      className={
        "px-3 py-1.5 text-sm bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg border border-slate-300 flex items-center gap-1 " +
        className
      }
    >
      ← {label}
    </button>
  );
}
